import { Row, Col } from "reactstrap";
import { BorderedBox, BorderedBoxEntry } from "pages/LessonRecord/components";

export const StudentReport = ({ studentReport }) => {
  return (
    <Row className="no-gutters">
      <Col sm="12">
        <BorderedBox>
          <BorderedBoxEntry
            label="Course"
            value={studentReport?.lesson_detail?.course?.name}
          />
          <BorderedBoxEntry
            label="Lesson"
            value={studentReport?.lesson_detail?.lesson?.name}
          />
        </BorderedBox>

        <div
          className="col-12 py-2  mb-4"
          style={{
            border: "2px solid #ffffff25",
            borderRadius: 8,
          }}
        >
          <div
            className="row pb-1"
            style={{
              borderBottom: "2px solid #ffffff25",
            }}
          >
            <dt className="col-4 text-primary">Trait Name</dt>
            <dt className="col-4 text-primary">Performance</dt>
            <dt className="col-4 text-primary">Comments</dt>
          </div>
          {studentReport?.traits?.map((trait, index) => (
            <div key={trait.id} className="row pt-2">
              <span className="col-4 text-white">{trait.name}</span>
              <span className="col-4  text-white">{trait.performance}</span>
              <span className="col-4  text-white">{trait.comments}</span>
            </div>
          ))}
        </div>
        <div
          className="col-12 py-2 mb-4"
          style={{
            border: "2px solid #ffffff25",
            borderRadius: 8,
          }}
        >
          <div
            className="row pb-1"
            style={{
              borderBottom: "2px solid #ffffff25",
            }}
          >
            <dt className="col-8 text-primary">Learning Objective</dt>
            <dt className="col-4 text-primary">Performance</dt>
          </div>
          {studentReport?.learning_objectives?.map(
            (learningObjective, index) => (
              <div key={learningObjective.id} className="row pt-2">
                <span className="col-8 text-white">
                  {learningObjective.name}
                </span>
                <span className="col text-white">
                  {learningObjective.performance}
                </span>
              </div>
            ),
          )}
        </div>
        <div
          className="col-12 py-2 mb-4"
          style={{
            border: "2px solid #ffffff25",
            borderRadius: 8,
          }}
        >
          <div
            className="row pb-1"
            style={{
              borderBottom: "2px solid #ffffff25",
            }}
          >
            <dt className="col-8 text-primary">Question</dt>
            <dt className="col-4 text-primary">Answer</dt>
          </div>
          {studentReport?.class_questions?.map((classQuestion, index) => (
            <div key={classQuestion.id + index} className="row pt-2">
              <span className="col-8 text-white">{classQuestion.question}</span>
              <span className="col text-white">{classQuestion.answer}</span>
            </div>
          ))}
        </div>
        <BorderedBox>
          {studentReport?.additional_comments?.map((comment, index) => (
            <BorderedBoxEntry
              key={index}
              label={comment.question}
              value={comment.answer}
            />
          ))}
        </BorderedBox>
      </Col>
    </Row>
  );
};
